import type { LoaderFunctionArgs } from "react-router-dom";
import { redirect } from "react-router-dom";
import { organizationAPI, APIError } from "../../lib/api";
import type {
  OrganizationResponse,
  OrganizationPermissions,
  ApiKeyResponse,
} from "../../types/api";

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function isValidUUID(value: string): boolean {
  return UUID_REGEX.test(value);
}

export interface ApiKeysData {
  organization: OrganizationResponse;
  permissions: OrganizationPermissions;
  apiKeys: ApiKeyResponse[];
}

export async function apiKeysLoader({ params }: LoaderFunctionArgs): Promise<ApiKeysData> {
  const { id } = params;

  if (!id || !isValidUUID(id)) {
    throw redirect("/organizations");
  }

  try {
    const [orgResponse, apiKeys] = await Promise.all([
      organizationAPI.getById(id),
      organizationAPI.getApiKeys(id),
    ]);

    return {
      organization: orgResponse.organization,
      permissions: orgResponse.permissions,
      apiKeys,
    };
  } catch (error) {
    if (error instanceof APIError && error.statusCode === 404) {
      throw redirect("/organizations");
    }
    throw error;
  }
}
